module.exports = __webpack_public_path__ + "static/media/whatsdown_black.61aa4ccc.svg";